import { useCallback, useEffect, useState } from "react";
import { delete_size_row_permanent, edit_deleted_size, restore_sizes } from "../../reduxData/user/userAction";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import DeletePopup from "../../Modals/DeletePopup";
import RestorePopup from "../../Modals/RestorePopup";

const RestoreSizes = () => {

  const [sizes, setSizes] = useState();
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [sizeId, setSizeId] = useState("");

  const [openRestorePopup,setOpenRestorePopup] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const handleGetSizes = useCallback(async () => {
    const res = await restore_sizes();
    setSizes(res?.data?.data);
  }, []);

  const handleDelete = useCallback(
    (id) => {
      setOpenDeletePopup(true);
      setSizeId(id);
    },
    [openDeletePopup]
  );

  const handleDeleteSize = useCallback(async () => {
    const payload = {
      type_id: sizeId?.type_id,
      gender_id: sizeId?.gender_id,
      brand_id: sizeId?.brand_id,
    };
    console.log("suiz")
    const res = await delete_size_row_permanent(payload);
    if(res)
    handleGetSizes()
   
    setOpenDeletePopup(false);
    setSizeId("");
  }, [sizeId]);

  const handleRestore= useCallback((id)=>{
    setOpenRestorePopup(true);
    setSizeId(id);
  },[])

  const handleRestoreSize= useCallback(async()=>{
 const payload = {
       brand_id: sizeId?.brand_id,
      type_id: sizeId?.type_id,
      gender_id: sizeId?.gender_id,
      // category_id: sizeId?.category_id,
      is_deleted:false,
    };
    console.log("payload",payload)
    const res = await edit_deleted_size(payload);
      if(res)
    handleGetSizes()
   
    setOpenRestorePopup(false);
    setSizeId("");


  },[sizeId])

    const handleCategoryName =(data)=>{
  
    const filterData  = data?.map(i=>i?.id=="0"?"Default":i?.region);
    return filterData?.join(", ");
  }


  useEffect(() => {
    handleGetSizes();
  }, []);

  return (
    <div>
      <div className="container">
        <div className="flex-md-row flex-column gap-2 d-flex justify-content-between align-items-center mb-3">
          <h3 className="fw-600 col-md-6">Restore Sizes</h3>
          <button
          className="restore-link stox-color fs-6"
          onClick={() => navigate("/size")}
        >
          <i class="bi bi-card-list fs-5 me-1"></i>Sizes{" "}
        </button>
        </div>
        <table className="table-size ">
          <thead>
            <tr className="table-head">
              <th className="p-md-3 text-start p-1 text-nowrap">Sr No .</th>
              <th className="p-md-3 text-start p-1 text-nowrap">
                Product Category
              </th>
              <th className="p-md-3 text-start p-1 text-nowrap">Brand</th>
              <th className="p-md-3 text-start p-1 text-nowrap">Gender</th>
              {/* <th className="p-md-3 text-start p-1 text-nowrap">Category</th> */}
              <th className="text-start p-md-3 p-1 text-nowrap">Action</th>
            </tr>
          </thead>
          <tbody>
            {sizes?.length > 0 ? (
              sizes?.map((i, idx) => (
                <tr className="" key={i?.id}>
                  <td className="fs-6 fw-semibold text-nowrap ">{idx + 1}</td>
                  <td className="fs-6 fw-semibold text-nowrap text-capitalize">
                    {i?.product_type_name}
                  </td>
                  <td className="fs-6 fw-semibold text-nowrap">
                    {i?.brand_name || "Default"}
                  </td>
                  <td className="fs-6 fw-semibold text-nowrap">
                    {i?.gender_name}
                  </td>
                  {/* <td className="fs-6 fw-semibold text-nowrap">
                    {handleCategoryName(i?.category_ids) || "-"}
                  </td> */}
                  <td className="fs-6 fw-semibold text-nowrap">
                    {user?.role != "store-manager" && (
                      <Link
                        className="text-danger mx-1"
                        onClick={() => {
                          // handleDeleteRow(i)
                          handleDelete(i);
                        }}
                      >
                        <i className="bi bi-trash3"></i>
                      </Link>
                    )}
                    <i className="bi bi-eye mx-1 cursor-pointer " onClick={()=>navigate(`/view-deleted-size/${i?.type_id}/${i?.brand_id}/${i?.gender_id}`)}></i>
                    <Link className=" ms-1"
                    onClick={()=>handleRestore(i)}>♻️ </Link>
                  </td>
                </tr>
              ))
            ) : (
              <tr ><td colSpan={6} className="text-center">No data</td> </tr>
            )}
          </tbody>
        </table>
      </div>
      {openDeletePopup && (
        <DeletePopup
          open={openDeletePopup}
          setOpen={setOpenDeletePopup}
          label="Once deleted, the record is gone forever."
          handleDelete={handleDeleteSize}
        />
      )}
      {openRestorePopup && (
        <RestorePopup
          open={openRestorePopup}
          setOpen={setOpenRestorePopup}
          handleRestore={handleRestoreSize}
          label="Are you sure , you want to restore the size"
        />
      )}
    </div>
  );
};

export default RestoreSizes;
